import React from "react";
import { navigate } from "gatsby-link";
import styled from 'react-emotion';

const ContactFormContainer = styled.div`
  width: 100%;
`;

const ContactForm = styled.form`
  max-width: 100%;
  width: 400px;
  margin-left: auto;
  margin-right: auto;
  p {
    width: 100%;
  }
  label {
    width: 100%;
    text-align: left;
  }
  input {
    width: 100%;
    background: ${props => props.theme.colors.greyLightBg};
    border: 1px solid ${props => props.theme.colors.lightBlue};
    border-radius: 4px;
    padding: 0.2rem;
  }
  textarea {
    width: 100%;
    background: ${props => props.theme.colors.greyLightBg};
    border: 1px solid ${props => props.theme.colors.lightBlue};
    border-radius: 4px;
    padding: 0.2rem;
  }
`;

const StyledButton = styled.button`
  width: 100%;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.darkBlue};
  padding: 10px 30px 10px 30px;
  border: 1px solid ${props => props.theme.colors.white};
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition-duration: ${props => props.theme.transitionDuration};
  transition-duration: ${props => props.theme.transitionDuration};
  transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  margin-top: 2rem;
  margin-right: 1rem;
  &:hover {
    background-color: ${props => props.theme.colors.white};
    color: ${props => props.theme.colors.darkBlue};
  }
`;

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export default class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const form = e.target;
    fetch("/?no-cache=1", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...this.state
      })
    })
      .then(() => navigate(form.getAttribute("action")))
      .catch(error => alert(error));
  };

  render() {
    return (
      <ContactFormContainer>
        <ContactForm
          name="contact"
          method="post"
          action="/contactSuccess"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={this.handleSubmit}
        >
          {/* The `form-name` hidden field is required to support form submissions without JavaScript */}
          <input type="hidden" name="form-name" value="contact" />
          <p hidden>
            <label>
              Don’t fill this out:{" "}
              <input name="bot-field" onChange={this.handleChange} />
            </label>
          </p>
          <p>
            <label>
              Name<br />
              <input type="text" name="name" onChange={this.handleChange} />
            </label>
          </p>
          <p>
            <label>
              Email<br />
              <input type="email" name="email" onChange={this.handleChange} />
            </label>
          </p>
          <p>
            <label>
              Message<br />
              <textarea maxLength="150" name="message" onChange={this.handleChange} />
            </label>
          </p>
          <p>
            <StyledButton type="submit">Send</StyledButton>
          </p>
        </ContactForm>
      </ContactFormContainer>
    );
  }
}